import { beaconFail } from "./assertions.js";
export class SmartUrl {
    rawUrl;
    rawParams;
    constructor(rawUrl, rawParams) {
        this.rawUrl = rawUrl;
        this.rawParams = rawParams;
    }
    get url() {
        return this.ensureUrl().toString();
    }
    get protocol() {
        return this.ensureUrl().protocol;
    }
    get host() {
        return this.ensureUrl().host;
    }
    get path() {
        return this.ensureUrl().pathname;
    }
    getParamOrNull(value) {
        return this.rawParams.get(value);
    }
    getParamOrFail(value) {
        return (this.getParamOrNull(value) ??
            beaconFail(`Parameter '${value}' not found in query string '${this.rawParams.toString()}'`));
    }
    ensureUrl() {
        return this.rawUrl ?? beaconFail("URL is not set");
    }
}
export const UrlUtils = {
    parseUrl(value) {
        if (value.startsWith("http")) {
            const url = new URL(value);
            return new SmartUrl(url, url.searchParams);
        }
        else {
            return new SmartUrl(null, new URLSearchParams(value));
        }
    },
    parseCurrentUrl(from) {
        return this.parseUrl((from ?? window).location.href);
    },
};
//# sourceMappingURL=url-utils.js.map